import { Badge, Spinner } from '@/components/ui'

/**
 * running → spinner (info), completed → green, error → red (the backend also
 * presents stale running rows as error on read). Unknown values render
 * neutrally — the status column type is an open string.
 */
export function RunStatusChip({ status }: { status: string }) {
  if (status === 'running')
    return (
      <Badge variant="info" className="gap-1">
        <Spinner size="sm" aria-hidden="true" />
        running
      </Badge>
    )
  if (status === 'completed') return <Badge variant="success">completed</Badge>
  if (status === 'error') return <Badge variant="destructive">error</Badge>
  return <Badge variant="secondary">{status}</Badge>
}
